import React from 'react'

export default function Template2() {
  return (
    <div>
      
    </div>
  )
}
